







import { Vue, Component } from "@/shared/vuepack";

@Component
export default class UcbFooterCash extends Vue {
}
